import ApiCaller from '../ApiCaller';
import baseAjaxConfig from '../BaseAjaxConfig';
export const UPLOAD_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'UPLOAD_IMAGE_ERROR';
export function uploadImage(payload) {
    return dispatch => {
        dispatch(uploadImageRequest());
        let headers = Object.assign({}, baseAjaxConfig.headers);
        delete headers['Content-Type'];
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/self-serve/return/imageUpload',
            multipart: true,
            headers,
            action: UPLOAD_IMAGE_REQUEST
        }), payload).then(json => {
            dispatch(uploadImageSuccess(json['RESPONSE']));
            return json['RESPONSE'];
        }, err => {
            dispatch(uploadImageError(err));
        });
    };
}
const uploadImageRequest = () => {
    return {
        type: UPLOAD_IMAGE_REQUEST
    };
};
const uploadImageSuccess = response => {
    return {
        type: UPLOAD_IMAGE_SUCCESS,
        data: response
    };
};
const uploadImageError = error => {
    return {
        type: UPLOAD_IMAGE_ERROR,
        error
    };
};
